module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Avengers-Infinity-Wars.ac072b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Avengers-Infinity-Wars.jpg
// module id = eKJC
// module chunks = 0